import { LOCK_INTENTION_ORDER_STATUS, LOCK_SERVICE_ORDER_STATUS, LOCK_PERSON_TYPE, LOCK_OPEN_WAY, LOCK_REASON_TYPE, DELIVERY_TYPE } from '@/business/config'

export default {
  /**
   * @description 订单状态过滤
   * @param {Number} value 订单状态数值
   * @returns {String} 订单状态文字
   */
  orderStatus(value) {
    const orderStatus = ['', '待入住', '入住中', '已退房', '已过期', '', '', '已取消']
    return orderStatus[value]
  },

  /**
   * @description 格式化时间格式化为format格式
   * @param {Date} date
   * @returns {String} MM.dd
   * @returns {String} returnStr 如果返回的是默认时间的话，可以直接返回默认文案
   */
  fromDate(date, format, returnStr) {
    if (typeof date === 'number') {
      // 非法的日期格式
      if (isNaN(new Date(date).getTime())) return date

      return new Date(date).formatDate(format)
    }
    // 非法的日期格式
    if (isNaN(new Date(date.replace(/-/g, '/')).getTime())) return date

    // 如果返回的是2000-1-1的默认时间，可以直接返回默认字段retureStr
    if (String(date) === '2000-01-01 00:00:00' && returnStr) return returnStr

    return new Date(date.replace(/-/g, '/')).formatDate(format)
  },

  /**
   * @description 格式化时间格式化为MM月dd日格式
   * @param {Date} date
   * @returns {String} MM月dd日
   */
  // fromDate_day(date) {
  //   return new Date(date.replace(/-/g, '/')).formatDate('MM月dd日')
  // },

  /**
   * @description 格式化时间格式化为MM月dd日 HH:mm格式
   * @param {Date} date
   * @returns {String} MM月dd日 HH:mm
   */
  // fromDate_check(date) {
  //   return new Date(date.replace(/-/g, '/')).formatDate('MM月dd日 HH:mm')
  // },

  /**
   * @description 上传状态过滤
   * @param {Number} value 上传状态数值
   * @returns {String} 上传状态文字
   */
  recordStatus(value) {
    const recordStatus = ['', '未上传', '已上传', '部分上传']
    return recordStatus[value]
  },

  /**
   * @description 渠道来源过滤
   * @param {Number} value 渠道来源数值
   * @returns {String} 渠道来源文字
   */
  sourceFilter(value) {
    const sources = [
      { name: '线下客人' },
      { name: '途家网' },
      { name: '去哪儿网' },
      { name: '携程' },
      { name: '榛果' },
      { name: '小猪短租' },
      { name: '木鸟' },
      { name: '美团' },
      { name: '飞猪' },
      { name: '艺龙' },
      { name: '青芒果' },
      { name: '同程' },
      { name: 'airbnb' },
      { name: '蚂蚁短租' },
      { name: '业主自定' },
      { name: '其他' }]
    return sources[value].name
  },

  /**
   * @description 证件类型过滤
   * @param {Number} value 证件类型数值
   * @returns {String} 证件类型文字
   */
  idTypeFilter(value) {
    const idTypes = ['', '身份证', '护照', '港澳通行证', '台湾通行证']
    return idTypes[value]
  },

  /**
   * @description 门锁意向单状态过滤
   * @param {Number} value 门锁意向单状态数值
   * @returns {String} 门锁意向单状态文字
   */
  lockIntentionOrderStatusFilter(value) {
    const idTypes = LOCK_INTENTION_ORDER_STATUS.getNames()
    return idTypes[value]
  },
  /**
   * @description 门锁服务单状态过滤
   * @param {Number} value 门锁服务单状态数值
   * @returns {String} 门锁服务单状态文字
   */
  lockServiceOrderStatusFilter(value) {
    return LOCK_SERVICE_ORDER_STATUS.get(value)
  },

  /**
   * @description 开锁人身份过滤
   * @param {Number} value 开锁人身份数值
   * @returns {String} 开锁人身份文字
   */
  lockPersonTypeFilter(value) {
    const lockPersonTypes = LOCK_PERSON_TYPE.getNames()
    return lockPersonTypes[value]
  },
  /**
   * @description 开锁事由过滤
   * @param {Number} value 开锁事由数值
   * @returns {String} 开锁事由文字
   */
  lockReasonTypeFilter(value) {
    return LOCK_REASON_TYPE.get(value)
  },

  /**
   * @description 开锁方式过滤
   * @param {Number} value 开锁方式数值
   * @returns {String} 开锁方式文字
   */
  lockOpenWayFilter(value) {
    const lockOpenWays = LOCK_OPEN_WAY.getNames()
    return lockOpenWays[value]
  },
  /**
   * @description 配送方式过滤
   * @param {Number} value 配送方式数值
   * @returns {String} 配送方式文字
   */

  deliveryTypeFilter(value) {
    const deliveryTypes = DELIVERY_TYPE.getNames()
    return deliveryTypes[value]
  },

  /**
   * @description 阿拉伯数字转换为简写汉字
   * @param {Number} Num 需要转换的数字
   * @param {String} preStr 拼接前置字符串
   * @returns 转化后的简写汉字
   */
  Arabia_To_SimplifiedChinese(Num, preStr) {
    for (let i = Num.length - 1; i >= 0; i--) {
      Num = Num.replace(',', '')// 替换Num中的“,”
      Num = Num.replace(' ', '')// 替换Num中的空格
    }
    if (isNaN(Num)) { // 验证输入的字符是否为数字
      // alert("请检查小写金额是否正确");
      return
    }
    // 字符处理完毕后开始转换，采用前后两部分分别转换
    let part = String(Num).split('.')
    let newchar = ''
    // 小数点前进行转化
    for (let i = part[0].length - 1; i >= 0; i--) {
      if (part[0].length > 10) {
        // alert("位数过大，无法计算");
        return ''
      }// 若数量超过拾亿单位，提示
      let tmpnewchar = ''
      let perchar = part[0].charAt(i)
      switch (perchar) {
        case '0': tmpnewchar = '零' + tmpnewchar; break
        case '1': tmpnewchar = '一' + tmpnewchar; break
        case '2': tmpnewchar = '二' + tmpnewchar; break
        case '3': tmpnewchar = '三' + tmpnewchar; break
        case '4': tmpnewchar = '四' + tmpnewchar; break
        case '5': tmpnewchar = '五' + tmpnewchar; break
        case '6': tmpnewchar = '六' + tmpnewchar; break
        case '7': tmpnewchar = '七' + tmpnewchar; break
        case '8': tmpnewchar = '八' + tmpnewchar; break
        case '9': tmpnewchar = '九' + tmpnewchar; break
      }
      switch (part[0].length - i - 1) {
        case 1: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break
        case 2: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break
        case 3: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break
        case 4: tmpnewchar = tmpnewchar + '万'; break
        case 5: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break
        case 6: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break
        case 7: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break
        case 8: tmpnewchar = tmpnewchar + '亿'; break
        case 9: tmpnewchar = tmpnewchar + '十'; break
      }
      newchar = tmpnewchar + newchar
    }
    // 替换所有无用汉字，直到没有此类无用的数字为止
    while (newchar.search('零零') !== -1 || newchar.search('零亿') !== -1 || newchar.search('亿万') !== -1 || newchar.search('零万') !== -1) {
      newchar = newchar.replace('零亿', '亿')
      newchar = newchar.replace('亿万', '亿')
      newchar = newchar.replace('零万', '万')
      newchar = newchar.replace('零零', '零')
    }
    // 替换以“一十”开头的，为“十”
    if (newchar.indexOf('一十') === 0) {
      newchar = newchar.substr(1)
    }
    // 替换以“零”结尾的，为“”
    if (newchar.lastIndexOf('零') === newchar.length - 1) {
      newchar = newchar.substr(0, newchar.length - 1)
    }
    // 若有前置字符串则拼接
    return preStr ? preStr + newchar : newchar
  },

  currency(value, currencyType, decimalNumber, tailaStr) {
    if (isNaN(Number(value))) return value
    let valueStr = String(value)
    let integerStr = String(value)
    let decimal = ''
    // 小数
    if (valueStr.includes('.')) {
      let integer = valueStr.split('.')[0]
      integerStr = Number(integer).toLocaleString()
      if (decimalNumber) {
        decimal = valueStr.split('.')[1].substr(0, decimalNumber)
      }
    } else {
      integerStr = Number(valueStr).toLocaleString()
      decimal = ''
    }
    return `${currencyType || ''}${integerStr}${decimal ? '.' + decimal : ''}${tailaStr || ''}`
  }
}
